var _path, _path2, _rect, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 57 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9416 9.18353H11.8582C9.32693 9.18353 7.2749 11.1945 7.2749 13.6752V45.1169C7.2749 47.5975 9.32693 49.6085 11.8582 49.6085H43.9416C46.4729 49.6085 48.5249 47.5975 48.5249 45.1169V13.6752C48.5249 11.1945 46.4729 9.18353 43.9416 9.18353Z",
    stroke: "#562C8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2749 22.6585H48.5249",
    stroke: "#562C8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.6001,
    y: 30.5,
    width: 27.4,
    height: 27.4,
    rx: 10.5,
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3001 43.188V44.2C53.2988 46.572 52.5307 48.8801 51.1104 50.78C49.6901 52.6798 47.6938 54.0697 45.419 54.7422C43.1443 55.4148 40.7131 55.334 38.4881 54.512C36.263 53.69 34.3633 52.1707 33.0722 50.1807C31.7811 48.1908 31.1679 45.8368 31.324 43.4699C31.4801 41.103 32.3971 38.8499 33.9382 37.0467C35.4794 35.2436 37.5622 33.9869 39.8759 33.4641C42.1897 32.9414 44.6104 33.1805 46.7771 34.146",
    stroke: "#562C8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3001 35.4L42.3001 46.411L39.0001 43.111",
    stroke: "#562C8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/check-box.d5965cf18b60395140c4d5b86cc07ada.svg";
export { ForwardRef as ReactComponent };